import Logo from "../../../assets/img/NewsImgs/newLogo.webp"
import { Link } from "react-router-dom";
const ResponsiveNavbarRight = () =>{

    return(
        <Link to={"/"}>
       <img src={Logo} className="w-[70px]"/>
        </Link>
    )
}

export default ResponsiveNavbarRight;